var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-form',{ref:"form",attrs:{"formModel":_vm.formModel}})
}
var staticRenderFns = []

export { render, staticRenderFns }